import { createActions, createReducer } from 'reduxsauce';
import { ISliderProps } from 'components/Slider/interface';

export const { Types, Creators } = createActions({
  openSlider: ['data'],
  closeSlider: []
});

const INITIAL_STATE: ISliderProps = {
  title: '',
  subtitle: '',
  content: undefined,
  state: {},
};

const openSlider = (state = INITIAL_STATE, action: any) => ({
  ...action.data, show: true
});

const closeSlider = (state = INITIAL_STATE, action: any) => ({
  title: '',
  subtitle: '',
  content: undefined
});

export default createReducer(INITIAL_STATE, {
  [Types.OPEN_SLIDER as any]: openSlider,
  [Types.CLOSE_SLIDER as any]: closeSlider
});